(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-sizes-drawer"] && !Shopify.designMode) return;
  try {
    class CompareSizesDrawer {
    constructor() {
      document.querySelectorAll('[data-compare-drawer]').forEach((dialog) => this.initDialog(dialog));
    }

    close(dialog) {
      dialog.classList.add('dialog-closing');
      setTimeout(() => {
        dialog.close();
        dialog.classList.remove('dialog-closing');
      }, 300);
    }

    initDialog(dialog) {
      const closeBtn = dialog.querySelector('[data-close-drawer]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close(dialog));

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) this.close(dialog);
      });

      dialog.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close(dialog);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CompareSizesDrawer());
  } else {
    new CompareSizesDrawer();
  }
  } catch(e) { console.error(e); }
})();

})();
